import React from "react";
import PropTypes from "prop-types";
import classcat from "classcat";

import "./tab.scss";

const InsuranceTab = ({ name, activeTab, handlerClick }) => {
  return (
    <p
      className={classcat([{ active: activeTab }, "tab-item"])}
      style={{
        width: `${
          activeTab ? (name.length + 1) * 10 + 50 : (name.length + 1) * 10
        }px`,
      }}
      onClick={handlerClick}
      role="presentation"
    >
      <span className="tab-title">{name}</span>
    </p>
  );
};

InsuranceTab.defaultProps = { activeTab: false };
InsuranceTab.propTypes = {
  name: PropTypes.string.isRequired,
  activeTab: PropTypes.bool,
  handlerClick: PropTypes.func.isRequired,
};

export default InsuranceTab;
